<template>
    <div>
        <ul class="img-list clearfloat">
            <li v-for="(url, index) in data" :style="{
                width: lyWidth + 'px',
                height: lyWidth + 'px'
            }" :key="index">

                <img v-if="getFileExtension(url) != 'pdf'" 
                :src="axios.platConfig.fileUri + url" @click="img(index)" />
                <pdf class="pdf" :url="url" v-if="getFileExtension(url) == 'pdf'">pdf</pdf>
            </li>
            <viewer v-show="false"  v-if="!utils.isEmpty(data)">
                <img v-for="(url, index) in data" :key="index" 
                :src="axios.platConfig.fileUri + url" width="30"
                    height="30" ref="img" />
            </viewer>
        </ul>
        <!-- <viewer v-if="!utils.isEmpty(data)">
            <img class="caijian" v-for="(x, index) in imgList" :key="index" :src="axios.platConfig.fileUri + x" />

        </viewer> -->
    </div>


</template>
<script>
import pdf from "./pdf.vue";
export default {
    components: { pdf },
    props: ['data'],
    data() {
        return {
            imgList: [],
            pdfList: [],
            lyWidth: 40,
            imgmmm:true
        }
    },
    methods: {
        fenlei() {
            this.imgList = [];
            this.pdfList = [];
            let data = this.data;
            for (let i = 0; i < data.length; i++) {
                if (this.getFileExtension(data[i]) == 'pdf') {
                    this.pdfList.push(data[i]);
                } else {
                    this.imgList.push(data[i]);
                }
            }
        },
        getFileExtension(filename) {
            return filename.split('.').pop().toLowerCase();
        },
        img(index) {
            var a = this.$refs.img[index];
            a.click();
        },
    },
    mounted() {
        this.fenlei();
    },
    watch: {
        data() {
            this.fenlei();
        }
    }
}
</script>
<style>
.caijian {
    width: 60px;
    height: 60px;
    margin-right: 4px;
    object-fit: cover;
    /* 裁剪并覆盖到容器 */
    object-position: center;
}
.img-list {
  flex-wrap: wrap;
  display: flex;
  flex-wrap: wrap;
  width:100%;
}

.img-list > li {
  width: 60px;
  height: 60px;
  position: relative;
  margin-right: 10px;
  margin-bottom: 10px;
  
}

.img-list > li > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
    /* 裁剪并覆盖到容器 */
    object-position: center;
}
</style>


// WEBPACK FOOTER //
// ../common/src/components/imgList.vue